import { de } from '../../../lib/i18n/de';
import { MoneyInput } from '../../../components/finance/MoneyInput';
import { HoursInput } from '../../../components/finance/HoursInput';
import { FieldHelp } from '../../../components/forms/FieldHelp';
import type { ResourcesDraft } from '../../../lib/store/wizard';

interface StundensatzStepProps {
  resources: ResourcesDraft;
  onHoursChange: (hours: number | null) => void;
}

/** Sub-Step 4.2: Bereinigter Stundensatz (Stunden + abgeleiteter Stundensatz). */
export function StundensatzStep({ resources, onHoursChange }: StundensatzStepProps) {
  const t = de.steps.resources.subSteps.rate;
  const profit =
    resources.revenueCents !== null && resources.costsCents !== null
      ? resources.revenueCents - resources.costsCents
      : null;

  // Bereinigter Stundensatz = Profit (Cents) / Stunden / 100 (in Euro)
  // Wir liefern den Wert wieder in Cents zurück, weil MoneyInput auf Cents arbeitet.
  const ratePerHourCents =
    profit !== null && resources.hoursPerMonth !== null && resources.hoursPerMonth > 0
      ? Math.round(profit / resources.hoursPerMonth)
      : null;

  return (
    <div className="space-y-8">
      <p className="max-w-prose font-serif text-base italic text-stone-500 md:text-lg">{t.intro}</p>

      <div>
        <HoursInput
          value={resources.hoursPerMonth}
          onChange={onHoursChange}
          label={t.hoursLabel}
          hint={t.hoursHint}
          placeholder="z.B. 100"
        />
        <div className="mt-2">
          <FieldHelp pathKey="resources.rate.hours" />
        </div>
      </div>

      <div className="border-t border-stone-200 pt-6">
        <MoneyInput
          valueCents={ratePerHourCents}
          onChange={() => {
            // read-only
          }}
          label={t.rateLabel}
          hint={t.rateHint}
          readOnly
          allowNegative
        />
        <div className="mt-2">
          <FieldHelp pathKey="resources.rate.bereinigt" />
        </div>
      </div>
    </div>
  );
}
